// src/utils/helpers.js
import { format, parseISO, formatDistanceToNow } from 'date-fns';

const LA_TZ = 'America/Los_Angeles';

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  try {
    return new Date(dateStr).toLocaleDateString('en-US', { timeZone: LA_TZ, month: '2-digit', day: '2-digit', year: 'numeric' });
  } catch { return dateStr; }
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '—';
  try {
    return new Date(dateStr).toLocaleString('en-US', { timeZone: LA_TZ, month: '2-digit', day: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true });
  } catch { return dateStr; }
};

export const formatTime = (dateStr) => {
  if (!dateStr) return '—';
  try {
    return new Date(dateStr).toLocaleTimeString('en-US', { timeZone: LA_TZ, hour: 'numeric', minute: '2-digit', hour12: true });
  } catch { return dateStr; }
};

export const timeAgo = (dateStr) => {
  if (!dateStr) return '—';
  try { return formatDistanceToNow(parseISO(dateStr), { addSuffix: true }); }
  catch { return dateStr; }
};

export const intervalLabel = (minutes) => {
  if (minutes <= 15) return 'Q15';
  if (minutes <= 30) return 'Q30';
  if (minutes <= 60) return 'Q60';
  return 'Q180';
};

export const intervalBadgeClass = (minutes) => {
  if (minutes <= 15) return 'badge badge-q15';
  if (minutes <= 30) return 'badge badge-q30';
  if (minutes <= 60) return 'badge badge-q60';
  return 'badge badge-q180';
};

export const roleLabel = (role) => {
  const labels = { mht: 'MHT', nurse: 'Nurse', supervisor: 'Supervisor', admin: 'Admin' };
  return labels[role] || role;
};

export const now8601 = () => {
  // Return current time in America/Los_Angeles as a datetime-local string
  const now = new Date();
  const laTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
  const pad = n => String(n).padStart(2, '0');
  return `${laTime.getFullYear()}-${pad(laTime.getMonth()+1)}-${pad(laTime.getDate())}T${pad(laTime.getHours())}:${pad(laTime.getMinutes())}`;
};

export const getErrorMessage = (err) => {
  return err?.response?.data?.error
    || err?.response?.data?.errors?.[0]?.msg
    || err?.response?.data?.message
    || err?.message
    || 'An unexpected error occurred';
};
